import React from "react";
import PrintButton from "../PrintButton";
import { AllFileTypes } from "../../../services/Exam";

const DownloadButtons = ({
  isLoading,
  fileInfo,
  reportInfoError,
  downloadPdf,
  shouldDisplayDicomButton,
  shouldDisplayPngButton,
}) => {
  const buttonConfigs = [
    {
      shouldDisplay: true,
      condition: fileInfo?.pdf?.hasBlobStorageError,
    },
    {
      shouldDisplay: shouldDisplayDicomButton,
      fileType: AllFileTypes.dicom,
      condition: fileInfo?.dicom?.hasBlobStorageError,
    },
    {
      shouldDisplay: shouldDisplayPngButton,
      fileType: AllFileTypes.png,
      condition: fileInfo?.png?.hasBlobStorageError,
    },
  ];

  return buttonConfigs
    .filter((config) => config.shouldDisplay)
    .map((config, index) => (
      <PrintButton
        key={index}
        isLoading={isLoading || config.condition}
        handleDownloadPdf={downloadPdf}
        fileInfo={fileInfo}
        reportInfoError={reportInfoError}
        fileType={config.fileType}
      />
    ));
};

export default DownloadButtons;
